import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ProjectDialog = ({ open, setOpen, selectedProject, setAlertOpen }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="sm"
      fullWidth={true}
      PaperProps={{
        sx: {
          background: "rgba(10, 15, 30, 0.8)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "32px",
          color: "white",
          p: 2
        }
      }}
    >
      <DialogTitle sx={{ fontFamily: 'Outfit', fontWeight: 700, fontSize: '2rem' }}>
        {selectedProject.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.7)", mb: 3, fontSize: '1.1rem' }}>
          {selectedProject.description}
        </DialogContentText>
        <DialogContentText sx={{ color: "white" }}>
          <strong style={{ color: '#22d3ee' }}>Stack:&nbsp;</strong>
          {selectedProject.stack}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button 
            onClick={() => setOpen(false)} 
            sx={{ color: 'rgba(255,255,255,0.5)', '&:hover': { color: 'white' } }}
        >
            Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            selectedProject.url
              ? window.open(selectedProject.url, "_blank")
              : setAlertOpen(true);
            setOpen(false);
          }}
          sx={{ 
            borderRadius: '12px',
            background: 'linear-gradient(45deg, #22d3ee, #818cf8)',
            color: '#020617',
            fontWeight: 700,
            px: 3,
            '&:hover': { background: 'linear-gradient(45deg, #22d3ee, #818cf8)', opacity: 0.9 }
          }}
        >
          View Live Project
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectDialog;
